<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="element-box" style="height: 100px">
          <h5 class="form-header">
            Pedido &nbsp;
            <span v-if="current.numero != null"># {{ current.numero }}</span>
            &nbsp;
            <div
              class="badge"
              :class="{
                'badge-success': current.estado == 'A',
                'badge-warning': current.estado == 'B',
                'badge-danger': current.estado == '9',
              }"
            >
              <i class="os-icon os-icon-ui-09"></i>
              <span v-if="current.estado_str">{{ current.estado_str }}</span>
              <span v-if="!current.estado_str">En Proceso</span>
            </div>
            <div class="st-meta float-right">
              <div class="element-actions">
                <div class="form-header">
                  <button
                    class="btn btn-outline-dark"
                    type="button"
                    @click="imprimir"
                    :disabled="current.estado == 'A'"
                  >
                    <i class="fa fa-print"></i>
                    Imprimir
                  </button>
                  &nbsp;
                  <div class="btn-group">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        :class="{ disabled: !(current.estado == 'B') }"
                        @click="abrir"
                        :disabled="!(current.estado == 'B')"
                        href="#"
                      >
                        <i class="fa fa-unlock"></i>
                        Abrir Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="cerrar"
                        :disabled="!(current.estado == 'A')"
                        href="#"
                      >
                        <i class="fa fa-lock"></i>
                        Cerrar Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="anular"
                        :disabled="!(current.estado != '9')"
                        href="#"
                      >
                        <i class="fa fa-archive"></i>
                        Anular Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="anular"
                        :disabled="!(current.estado != '9')"
                        href="#"
                      >
                        <i class="fa fa-archive"></i>
                        Facturar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </h5>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
                >{{ current.errors.detail }}</small
              >
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for>Tienda</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-model="current.tienda.nombre"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for>Caja</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-model="current.caja.caja"
                        class="form-control"
                        placeholder="Caja"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.tipo_pago &&
                          current.errors.tipo_pago.length > 0,
                      }"
                      >Tipo de Pago</label
                    >
                    <select
                      class="form-control"
                      v-model="current.tipo_pago"
                      disabled
                    >
                      <option value="CONTADO">Contado</option>
                      <option value="CREDITO">Crédito</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Vendedor</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.vendedor"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for>Fecha</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-model="current.fecha"
                        class="form-control"
                        placeholder="Fecha"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3" v-if="current.cliente">
                  <div class="form-group">
                    <label>Nit del Cliente</label>
                    <div class="input-group">
                      <input
                        id="nit"
                        disabled
                        ref="nit"
                        v-if="current.cliente"
                        v-model="current.cliente.nit"
                        class="form-control"
                        placeholder="Nit"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-7" v-if="current.cliente">
                  <div class="form-group">
                    <label for>Nombre del Cliente</label>
                    <div class="input-group">
                      <input
                        id="nombre"
                        disabled
                        ref="nombre"
                        v-model="current.cliente.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for>Total de la factura</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-model="current.total"
                        class="form-control text-center"
                        placeholder="Nombre"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive" v-if="current.id != null">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sku</th>
                      <th>Descripción</th>
                      <th class="text-center">Cantidad</th>
                      <th class="text-center">Unidad Medida</th>
                      <th class="text-right">Precio</th>
                      <th class="text-right">Total</th>
                      <th class="text-center" v-if="current.estado == 'A'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.cxcpedidod_set"
                      v-bind:key="detalle.id"
                    >
                      <td>{{ detalle.producto.sku }}</td>
                      <td>{{ detalle.descripcion }}</td>
                      <td class="text-center">{{ detalle.cantidad_um }}</td>
                      <td class="text-center">
                        {{ detalle.unidad_medida.nombre }}
                      </td>
                      <td class="text-right">Q {{ detalle.precio }}</td>
                      <td class="text-right">Q {{ detalle.total }}</td>
                      <td class="text-center" v-if="current.estado == 'A'">
                        <button
                          class="btn btn-sm btn-danger mr-1"
                          type="button"
                          @click="deleteDetalle(detalle)"
                        >
                          <i class="fa fa-trash"></i>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    @click="showModalAddDetail"
                    v-if="current.estado == 'A'"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar Producto
                  </button>
                </div>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <CambiarClienteModalComponent
                :current="current"
                @refresh="refreshCurrent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="modalAddDetailReqCompra"
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-side-by-side">
            <div class="onboarding-content with-gradient col-8">
              <h4 class="onboarding-title">Agregar Servicio</h4>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.length > 0,
                    }"
                  ></label>
                  <ProductoSelectComponent
                    :current="currentDetalle"
                    @input="refreshImagen"
                  />
                  <small
                    v-if="currentDetalle.errors"
                    class="form-text text-danger"
                  ></small>
                </div>
              </div>
              <div
                v-if="currentDetalle.producto.es_servicio == true"
                class="col-sm-12"
              >
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.descripcion &&
                        currentDetalle.errors.descripcion.length > 0,
                    }"
                    >Descripción</label
                  >
                  <textarea
                    v-model="currentDetalle.descripcion"
                    class="form-control"
                    placeholder="Describa Servicio Realizado"
                    type="text"
                    style="font-size: 110%"
                    v-bind:class="{
                      'is-invalid':
                        currentDetalle.errors.descripcion &&
                        currentDetalle.errors.descripcion.length > 0,
                    }"
                  ></textarea>
                  <small
                    v-if="
                      currentDetalle.errors && currentDetalle.errors.descripcion
                    "
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.descripcion[0] }}</small
                  >
                </div>
              </div>
            </div>
            <div class="onboarding-media">
              <img
              style="hover: "
                class="img-fluid img-thumbnail"
                :src="imagen"
                width="285px"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle">Agregar</button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import PedidosServices from "@/services/pos/PedidosServices";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import CambiarClienteModalComponent from "@/components/pos/pos_servicios/CambiarClienteModalComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponent,
    CambiarClienteModalComponent,
  },
  data() {
    return {
      imagen: "",
      current: {
        agrupar_por_fardo: false,
        id: null,
        tipo: "V",
        caja: {
          caja: "",
        },
        cliente: {
          nit: "",
          nombre: "",
        },
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],

      productos: [],
      options: [],

      currentDetalle: {
        descripcion: null,
        cantidad: "",
        precio_actual: null,
        producto: {
          lista_precios: [],
        },
        unidad_medida: null,
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    refreshImagen() {
      let self = this;
      DynamicService.fetch("cat", "producto-imagen", {
        producto: self.currentDetalle.producto.sku,
      }).then((response) => {
        self.imagen = response.data.results[0].imagen;
      });
    },

    refreshCurrent() {
      let self = this;
      PedidosServices.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.vendedor = response.data.vendedor.name;
        self.current.fecha = self.customFormatterInverted(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = "";
      });
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add("days").format("YYYY-MM-DD");
    },

    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqCompra").modal();
      });
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      det.barra = det.producto.sku
      if (det.descripcion == null) {
        delete det.descripcion
      }
      PedidosServices.agregar_detalle(self.current.id, det)
        .then((response) => {
          $("#modalAddDetailReqCompra").modal("hide");
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
          self.refreshDetalleDefault();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          PedidosServices.eliminar_detalle(detalle.pedido_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          PedidosServices.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          PedidosServices.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          PedidosServices.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    imprimir() {
      let self = this;
      PedidosServices.pdf(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        descripcion: null,
        producto: {
          sku: null,
          errors: [],
        },
        errors: [],
      };
    },
  },
};
</script>
